import {
  h,
} from "vue";
import AbstractDialogTitle from "~/components/abstract-dialog/title.vue";
import DialogBody from "~/services/cancel-pending-order-dialog/body.vue";
import DialogFooter from "~/services/cancel-pending-order-dialog/footer.vue";
import {
  useDialogStoreV2,
} from "~/components/abstract-dialog/useDialogStoreV2";

type CancelPendingOrderDialogOptions = {
  title: string;
  message: string;
  confirmLabel: string;
};

export function confirmCancelPendingOrder(options: CancelPendingOrderDialogOptions) {
  const dialogStore = useDialogStoreV2();
  const resolution = defer<boolean>();

  const {hideDialog} = dialogStore.showDialog({
    titleComponent: h(AbstractDialogTitle, {
      title: options.title,
    }),
    bodyComponent: h(DialogBody, {
      message: options.message,
    }),
    footerComponent: h(DialogFooter, {
      confirmLabel: options.confirmLabel,
      onCancel: () => {
        resolution.resolve(false);
        hideDialog();
      },
      onConfirm: () => {
        resolution.resolve(true);
        hideDialog();
      },
    }),
    options: {
      dialogClass: "!w-[90%] !max-w-[480px] !rounded-2xl",
      dialogMinWidth: "",
      dialogMinHeight: "",
      allowCloseByEscape: true,
      onClose: () => {
        resolution.resolve(false);
      },
    },
  });

  return resolution.promise!;
}
